import React, { useEffect, useRef } from 'react';
import anime from 'animejs';

// Click anywhere inside `target` and a burst of shapes radiates outward.
const ClickBurst = ({ targetRef, count = 14, color = '#ff2a2a' }) => {
    const layerRef = useRef(null);

    useEffect(() => {
        const target = targetRef?.current || document.body;
        const layer = layerRef.current;
        if (!target || !layer) return;

        const handleClick = (e) => {
            const rect = layer.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            const fragments = [];
            for (let i = 0; i < count; i++) {
                const el = document.createElement('span');
                const shapeRoll = i % 3;
                el.style.position = 'absolute';
                el.style.left = `${x}px`;
                el.style.top = `${y}px`;
                el.style.pointerEvents = 'none';
                el.style.width = '8px';
                el.style.height = '8px';
                el.style.background = color;
                el.style.opacity = '0.9';
                el.style.boxShadow = `0 0 10px ${color}`;
                if (shapeRoll === 0) el.style.borderRadius = '999px';
                else if (shapeRoll === 1) el.style.borderRadius = '2px';
                else {
                    el.style.background = 'transparent';
                    el.style.borderLeft = '6px solid transparent';
                    el.style.borderRight = '6px solid transparent';
                    el.style.borderBottom = `10px solid ${color}`;
                    el.style.width = '0';
                    el.style.height = '0';
                }
                layer.appendChild(el);
                fragments.push(el);
            }

            anime({
                targets: fragments,
                translateX: () => anime.random(-160, 160),
                translateY: () => anime.random(-160, 160),
                rotate: () => anime.random(-540, 540),
                scale: [
                    { value: 1.6, duration: 250 },
                    { value: 0, duration: 700 },
                ],
                opacity: [
                    { value: 1, duration: 0 },
                    { value: 0, duration: 900 },
                ],
                easing: 'easeOutCubic',
                duration: 900,
                complete: () => fragments.forEach((f) => f.remove()),
            });
        };

        target.addEventListener('click', handleClick);
        return () => target.removeEventListener('click', handleClick);
    }, [targetRef, count, color]);

    return <div ref={layerRef} className="absolute inset-0 pointer-events-none overflow-hidden z-30" aria-hidden="true" />;
};

export default ClickBurst;
